import React, { useState } from 'react';

export function teamSizeLabel(team) {
  return `${team.agents} agents - $${team.price}/month (${team.homeowners} homeowners, shared)`;
}

const controlStyle = {
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: '100%',
  minHeight: '44px',
  height: 'auto',
  padding: '0.75rem 2.25rem 0.75rem 0.75rem',
  borderRadius: '8px',
  fontSize: '1rem',
  lineHeight: 1.4,
  textAlign: 'left',
  whiteSpace: 'normal',
  overflow: 'visible',
  textOverflow: 'clip',
  cursor: 'pointer',
};

/**
 * Team-size choices wrap instead of clipping inside a native select.
 */
const TeamSizePicker = ({
  value,
  options,
  onChange,
  borderColor = '#ccc',
  background = '#fff',
  textColor = '#111',
}) => {
  const [open, setOpen] = useState(false);
  const plans = options || [];
  const selected = plans.find((team) => team.agents === value) || plans[0];
  if (!selected) return null;

  return (
    <div className="team-size-picker" style={{ width: '100%', maxWidth: '100%', marginBottom: '1rem' }}>
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={`Team size, ${teamSizeLabel(selected)}`}
        onClick={() => setOpen((current) => !current)}
        style={{
          ...controlStyle,
          border: `2px solid ${borderColor}`,
          background,
          color: textColor,
        }}
      >
        {teamSizeLabel(selected)}
      </button>
      {open && (
        <div
          role="listbox"
          aria-label="Team size"
          style={{
            marginTop: '0.35rem',
            border: `2px solid ${borderColor}`,
            borderRadius: '8px',
            background,
            overflow: 'visible',
          }}
        >
          {plans.map((team) => {
            const label = teamSizeLabel(team);
            const isSelected = team.agents === selected.agents;
            return (
              <button
                key={team.agents}
                type="button"
                role="option"
                aria-selected={isSelected}
                onClick={() => {
                  onChange(team.agents);
                  setOpen(false);
                }}
                style={{
                  ...controlStyle,
                  display: 'block',
                  border: 'none',
                  borderBottom: `1px solid ${borderColor}`,
                  borderRadius: 0,
                  background: isSelected ? 'rgba(89, 196, 196, 0.15)' : 'transparent',
                  color: textColor,
                  fontWeight: isSelected ? 650 : 400,
                }}
              >
                {label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TeamSizePicker;
